"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetEnquiryDetailsResponseDtoStatusEnum = exports.GetEnquiryDetailsResponseDtoEnquiryTypeEnum = void 0;
exports.instanceOfGetEnquiryDetailsResponseDto = instanceOfGetEnquiryDetailsResponseDto;
exports.GetEnquiryDetailsResponseDtoFromJSON = GetEnquiryDetailsResponseDtoFromJSON;
exports.GetEnquiryDetailsResponseDtoFromJSONTyped = GetEnquiryDetailsResponseDtoFromJSONTyped;
exports.GetEnquiryDetailsResponseDtoToJSON = GetEnquiryDetailsResponseDtoToJSON;
exports.GetEnquiryDetailsResponseDtoToJSONTyped = GetEnquiryDetailsResponseDtoToJSONTyped;
var ListPropertySummaryDetailDto_1 = require("./ListPropertySummaryDetailDto");
var RegisteredInspectionDetailDto_1 = require("./RegisteredInspectionDetailDto");
var EnquiryDetailsListingDto_1 = require("./EnquiryDetailsListingDto");
var GeneralEnquiryDetailDto_1 = require("./GeneralEnquiryDetailDto");
var PropertyLeadDetailDto_1 = require("./PropertyLeadDetailDto");
var DocumentRequestDetailDto_1 = require("./DocumentRequestDetailDto");
var PropertyValuationDetailDto_1 = require("./PropertyValuationDetailDto");
/**
 * @export
 */
exports.GetEnquiryDetailsResponseDtoEnquiryTypeEnum = {
    Inspection: 'inspection',
    DocumentRequest: 'document_request',
    GeneralEnquiry: 'general_enquiry',
    ListingCrmEnquiry: 'listing_crm_enquiry',
    PropertyValuation: 'property_valuation',
    ListProperty: 'list_property'
};
/**
 * @export
 */
exports.GetEnquiryDetailsResponseDtoStatusEnum = {
    InProgress: 'in_progress',
    Open: 'open',
    Resolved: 'resolved'
};
/**
 * Check if a given object implements the GetEnquiryDetailsResponseDto interface.
 */
function instanceOfGetEnquiryDetailsResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('enquiryType' in value) || value['enquiryType'] === undefined)
        return false;
    if (!('inquirer' in value) || value['inquirer'] === undefined)
        return false;
    if (!('enquiryReceiver' in value) || value['enquiryReceiver'] === undefined)
        return false;
    if (!('isListingOwner' in value) || value['isListingOwner'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function GetEnquiryDetailsResponseDtoFromJSON(json) {
    return GetEnquiryDetailsResponseDtoFromJSONTyped(json, false);
}
function GetEnquiryDetailsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'enquiryId': json['enquiryId'] == null ? undefined : json['enquiryId'],
        'enquiryType': json['enquiryType'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'receiverId': json['receiverId'] == null ? undefined : json['receiverId'],
        'inquirer': json['inquirer'],
        'enquiryReceiver': json['enquiryReceiver'],
        'isListingOwner': json['isListingOwner'],
        'status': json['status'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'generalEnquiry': json['generalEnquiry'] == null ? undefined : (0, GeneralEnquiryDetailDto_1.GeneralEnquiryDetailDtoFromJSON)(json['generalEnquiry']),
        'documentRequests': json['documentRequests'] == null ? undefined : (0, DocumentRequestDetailDto_1.DocumentRequestDetailDtoFromJSON)(json['documentRequests']),
        'registeredInspections': json['registeredInspections'] == null ? undefined : (0, RegisteredInspectionDetailDto_1.RegisteredInspectionDetailDtoFromJSON)(json['registeredInspections']),
        'propertyLeads': json['propertyLeads'] == null ? undefined : (0, PropertyLeadDetailDto_1.PropertyLeadDetailDtoFromJSON)(json['propertyLeads']),
        'propertyValuationRequests': json['propertyValuationRequests'] == null ? undefined : (0, PropertyValuationDetailDto_1.PropertyValuationDetailDtoFromJSON)(json['propertyValuationRequests']),
        'listPropertySummary': json['listPropertySummary'] == null ? undefined : (0, ListPropertySummaryDetailDto_1.ListPropertySummaryDetailDtoFromJSON)(json['listPropertySummary']),
        'listing': json['listing'] == null ? undefined : (0, EnquiryDetailsListingDto_1.EnquiryDetailsListingDtoFromJSON)(json['listing']),
    };
}
function GetEnquiryDetailsResponseDtoToJSON(json) {
    return GetEnquiryDetailsResponseDtoToJSONTyped(json, false);
}
function GetEnquiryDetailsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'enquiryId': value['enquiryId'],
        'enquiryType': value['enquiryType'],
        'userId': value['userId'],
        'receiverId': value['receiverId'],
        'inquirer': value['inquirer'],
        'enquiryReceiver': value['enquiryReceiver'],
        'isListingOwner': value['isListingOwner'],
        'status': value['status'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'generalEnquiry': (0, GeneralEnquiryDetailDto_1.GeneralEnquiryDetailDtoToJSON)(value['generalEnquiry']),
        'documentRequests': (0, DocumentRequestDetailDto_1.DocumentRequestDetailDtoToJSON)(value['documentRequests']),
        'registeredInspections': (0, RegisteredInspectionDetailDto_1.RegisteredInspectionDetailDtoToJSON)(value['registeredInspections']),
        'propertyLeads': (0, PropertyLeadDetailDto_1.PropertyLeadDetailDtoToJSON)(value['propertyLeads']),
        'propertyValuationRequests': (0, PropertyValuationDetailDto_1.PropertyValuationDetailDtoToJSON)(value['propertyValuationRequests']),
        'listPropertySummary': (0, ListPropertySummaryDetailDto_1.ListPropertySummaryDetailDtoToJSON)(value['listPropertySummary']),
        'listing': (0, EnquiryDetailsListingDto_1.EnquiryDetailsListingDtoToJSON)(value['listing']),
    };
}
